export interface LogLevel {
  label: string;
  sortOrder: number;
}

export type LogLevelLabel =
  | "none"
  | "fatal"
  | "error"
  | "warning"
  | "info"
  | "debug";

export class LogLevels {
  static None: LogLevel = { label: "none", sortOrder: 0 };
  static Fatal: LogLevel = { label: "fatal", sortOrder: 1 };
  static Error: LogLevel = { label: "error", sortOrder: 2 };
  static Warn: LogLevel = { label: "warning", sortOrder: 3 };
  static Info: LogLevel = { label: "info", sortOrder: 4 };
  static Debug: LogLevel = { label: "debug", sortOrder: 5 };
  static Trace: LogLevel = { label: "trace", sortOrder: 6 };

  static equals(a: LogLevel, b: LogLevel): boolean {
    return a.sortOrder === b.sortOrder;
  }

  static lessThanOrEqual(a: LogLevel, b: LogLevel): boolean {
    return a.sortOrder <= b.sortOrder;
  }

  static greaterThan(a: LogLevel, b: LogLevel): boolean {
    return a.sortOrder > b.sortOrder;
  }

  static fromString(label: string): LogLevel {
    switch (label) {
      case "fatal":
        return LogLevels.Fatal;
      case "error":
        return LogLevels.Error;
      case "warning":
        return LogLevels.Warn;
      case "info":
        return LogLevels.Info;
      case "debug":
        return LogLevels.Debug;
      case "trace":
        return LogLevels.Trace;
      case "none":
      default:
        return LogLevels.None;
    }
  }

  static getAll(): LogLevel[] {
    return [
      LogLevels.None,
      LogLevels.Fatal,
      LogLevels.Error,
      LogLevels.Warn,
      LogLevels.Info,
      LogLevels.Debug,
      LogLevels.Trace,
    ];
  }
}
